import React from 'react';
import type { FullLayoutProps } from '@v2/shared/lib/types';

import Content from './Content';
import Footer from './Footer';
import Navigation from './Navigation';

/**
 * The chrome every MagSpot page shares.
 *
 * The third brand's `Layouts.Full`, and the first with no headless app behind it —
 * MagSpot never had one, so this is ported from the site's own legacy tSys templates
 * (`domain-overrides/magspot.com/layouts/full/header.html` and `.../footer.html`) rather
 * than from another framework's components. Where those templates render something the
 * V2 tree already has a component for, the V2 one is used; nothing is reproduced twice.
 *
 * Same layout name and same props as the other brands' — a page declares
 * `layoutName = 'Layouts.Full'` and gets this without knowing which brand it is on.
 *
 * Structurally MagSpot's header is in normal flow, like TopMags' and unlike
 * DiscountMags', so nothing here measures a header height. The page is white rather than
 * TopMags' grey card, which is what the legacy site does.
 *
 * `displaySitewideBanner` is destructured off deliberately, as on TopMags: it is part of
 * the shared props contract and MagSpot has no banner to draw, so it is dropped here
 * rather than spread onto Navigation as an unknown attribute.
 */
export default function Full({
  children,
  displaySitewideBanner,
  categories,
  copyrightYear,
}: FullLayoutProps) {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navigation categories={categories} />
      <Content>{children}</Content>
      <Footer copyrightYear={copyrightYear} />
    </div>
  );
}
